import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ConfigGuard } from '@occc-app/App/guards';
import { Can } from '@occc-app/App/PolicyBasedAccessControl/components/Can';
import { ReadRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';
import UnauthorizedPage from '@occc-app/routes/Unauthorized';

import { RetailerNetworkViewGuard } from '../guards/retailer-network-view.guard';

type RetailerNetworkDetailsPageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkDetailsPageGuard = ({
  children,
}: RetailerNetworkDetailsPageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <ConfigGuard isFeatureEnabled={(config) => !!config.retailerConnect?.enabled}>
      <RetailerNetworkViewGuard>
        <Can I={ReadRetailerNetwork({ uuid: networkId })} fallback={<UnauthorizedPage />}>
          {children}
        </Can>
      </RetailerNetworkViewGuard>
    </ConfigGuard>
  );
};
